import { formatAssetAmount, formatPrice } from '@exodus/formatting'

const FeeDetails = ({ value, visible, fiatMode, feeAsset, onFiatModePress }) => {
  if (!visible) return null

  const formattedValue = fiatMode
    ? formatPrice(value.toDefaultNumber(), { currency: value.currency })
    : `${formatAssetAmount(value)} ${feeAsset.displayTicker}`

  return (
    <button className="text-center text-xs text-white opacity-30" onClick={onFiatModePress}>
      Fees: {formattedValue}
    </button>
  )
}

export default FeeDetails
